import ar from './ar';
import en from './en';
import de from './de';

export const translations = {
  ar,
  en,
  de,
};

export { ar, en, de };
export default translations;
